import { InputNumber } from "element-ui";
import FormBase from "./FormBase";
export default {
  name: "AceInputNumber",
  mixins: [InputNumber, FormBase],
  data() {
    return {
      isAuth: true,
    };
  },
  computed: {
    inputNumberDisabled() {
      return this.disabled || (this.elForm || {}).disabled || this.isOperationDisabled() || !this.isAuth;
    },
  },
};
